var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoConnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 80,
    viewBox: "0 0 68 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0372 30.3679C42.147 30.3679 48.7212 23.7937 48.7212 15.684C48.7212 7.57423 42.147 1 34.0372 1C25.9275 1 19.3533 7.57423 19.3533 15.684C19.3533 23.7937 25.9275 30.3679 34.0372 30.3679Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0144 27.8437C40.7429 27.8437 46.1975 22.3892 46.1975 15.6606C46.1975 8.9321 40.7429 3.47754 34.0144 3.47754C27.2859 3.47754 21.8313 8.9321 21.8313 15.6606C21.8313 22.3892 27.2859 27.8437 34.0144 27.8437Z",
    fill: "currentColor",
    fillOpacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0778 74.4198C67.0778 56.1729 52.2858 41.3809 34.0389 41.3809C15.7921 41.3809 1 56.1729 1 74.4198",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0793 58.2224C27.7864 57.9295 27.3115 57.9295 27.0186 58.2224C26.7257 58.5153 26.7257 58.9901 27.0186 59.283L32.9777 65.2422L27.0186 71.2013C26.7257 71.4942 26.7257 71.9691 27.0186 72.262C27.3115 72.5549 27.7864 72.5549 28.0793 72.262L34.0384 66.3028L39.9975 72.262C40.2904 72.5548 40.7653 72.5548 41.0582 72.262C41.3511 71.9691 41.3511 71.4942 41.0582 71.2013L35.0991 65.2422L41.0582 59.2831C41.3511 58.9902 41.3511 58.5153 41.0582 58.2224C40.7653 57.9295 40.2904 57.9295 39.9975 58.2224L34.0384 64.1815L28.0793 58.2224Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoConnection);
export default __webpack_public_path__ + "static/media/no-connection.17782c7d3c8cbb0192fcf3b20304e16f.svg";
export { ForwardRef as ReactComponent };